import { CreditCardStatementsResponse } from "@/models/api/finances/CreditCardStatementsListItem";

export default {
  page: 1,
  totalCount: 384,
  items: [
    {
      id: 565,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 9175",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-10-07T08:08:58.08",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 564,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 8939",
      currency: "PLN",
      fromDate: "2020-10-01T00:00:00",
      toDate: "2020-10-31T23:59:59.997",
      createdAt: "2020-10-07T08:08:55.6",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/10/2020/5543",
    },
    {
      id: 563,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 3419",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-10-07T08:08:19.783",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 562,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 3351",
      currency: "PLN",
      fromDate: "2020-10-01T00:00:00",
      toDate: "2020-10-31T23:59:59.997",
      createdAt: "2020-10-07T08:08:19.753",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/10/2020/5543",
    },
    {
      id: 561,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 3351",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-10-07T08:08:19.69",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 560,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 1611",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-10-07T08:08:19.627",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 559,
      bankType: 1,
      creditCardNumber: "SPŁATA KART",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-09-08T14:49:15.703",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 558,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 8939",
      currency: "PLN",
      fromDate: "2020-09-01T00:00:00",
      toDate: "2020-09-30T23:59:59.997",
      createdAt: "2020-09-08T14:49:14.187",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/09/2020/5543",
    },
    {
      id: 557,
      bankType: 1,
      creditCardNumber: "5476 XXXX XXXX 3351",
      currency: "PLN",
      fromDate: "2020-08-01T00:00:00",
      toDate: "2020-08-31T23:59:59.997",
      createdAt: "2020-09-08T14:48:52.847",
      createdBy: "wpaszko",
      statementNumber: "RKB/1/08/2020/5543",
    },
    {
      id: 556,
      bankType: 1,
      creditCardNumber: "SPŁATA KART",
      currency: "PLN",
      fromDate: "2020-08-01T00:00:00",
      toDate: "2020-08-31T23:59:59.997",
      createdAt: "2020-08-11T10:28:16.573",
      createdBy: "korzechowski",
      statementNumber: "RKB/1/08/2020/5543",
    },
  ],
} as CreditCardStatementsResponse;
